var _a;
import { error, log } from "https://gipys.it/cdn/shop/t/26/assets/utils.js?v=135562944996829353651782472049";
const REGISTRY = {};
const LOADING = /* @__PURE__ */ new Map();
const CRITICAL_COMPONENTS = ["mc-swiper", "mc-header", "mc-btn"];
const isCE = (tag) => tag.includes("-");
(_a = window.theme.components) == null ? void 0 : _a.forEach((url) => {
  var _a2;
  const filename = (_a2 = url.split("/").pop()) != null ? _a2 : "";
  const tag = filename.replace(/\.js(\?.*)?$/, "");
  if (isCE(tag)) {
    REGISTRY[tag] = () => import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      url
    ).then((mod) => {
      log(`Component loaded: ${tag}`);
      return mod;
    });
  }
});
function ensureLoaded(tag) {
  if (!REGISTRY[tag]) return;
  if (customElements.get(tag)) return;
  if (LOADING.has(tag)) return;
  const p = REGISTRY[tag]().catch((e) => {
    error(`Error loading ${tag}:`, e);
    throw e;
  }).finally(() => LOADING.delete(tag));
  LOADING.set(tag, p);
}
function schedule(el) {
  var _a2, _b;
  const tag = (_b = (_a2 = el.tagName) == null ? void 0 : _a2.toLowerCase) == null ? void 0 : _b.call(_a2);
  if (!tag || !isCE(tag)) return;
  ensureLoaded(tag);
}
function init() {
  const keys = Object.keys(REGISTRY);
  CRITICAL_COMPONENTS.forEach((tag) => {
    if (REGISTRY[tag]) {
      ensureLoaded(tag);
    }
  });
  if (keys.length) {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => {
        document.querySelectorAll(keys.join(",")).forEach(schedule);
      });
    } else {
      setTimeout(() => {
        document.querySelectorAll(keys.join(",")).forEach(schedule);
      }, 1);
    }
  }
  const mo = new MutationObserver((recs) => {
    for (const r of recs) {
      for (const n of r.addedNodes) {
        if (!(n instanceof Element)) continue;
        schedule(n);
        if (keys.length) n.querySelectorAll(keys.join(",")).forEach(schedule);
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
}
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init, { once: true });
} else {
  init();
}
window.addEventListener("error", (ev) => {
  error(
    `window.error: ${ev.message || "(no message)"} @ ${ev.filename || ""}:${ev.lineno || ""}:${ev.colno || ""}`
  );
}, true);
window.addEventListener("unhandledrejection", (ev) => {
  const reason = (ev == null ? void 0 : ev.reason) instanceof Error ? `${ev.reason.name}: ${ev.reason.message}` : String(ev == null ? void 0 : ev.reason);
  error(`unhandledrejection: ${reason}`);
});
window.addEventListener("pageshow", () => {
  document.body.classList.add("mc-page-loaded");
});
let ticking = false;
const offset = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--topbar").trim().replace("px", "")) || 0;
function onScroll() {
  if (!ticking) {
    window.requestAnimationFrame(() => {
      if (window.scrollY > offset) {
        document.body.classList.add("scroll");
      } else {
        document.body.classList.remove("scroll");
      }
      ticking = false;
    });
    ticking = true;
  }
}
onScroll();
window.addEventListener("scroll", onScroll, { passive: true });
